import React, { useEffect } from 'react';
import '../styles/forpasiNewsPage.css'; // Import CSS baru untuk halaman berita
//import { useLanguage } from '../../../contexts/LanguageContext'; // Asumsi ini ada
//import { highlightIndonesiaLestari } from '../../../utils/textHelper'; // Asumsi ini ada

// --- Dummy Data ---
// Ganti dengan path atau URL gambar asli jika ada
import HeroImage from '../../assets/carousel-1.jpg'; 
import GroupImage from '../../assets/carousel-1.jpg'; 
import DiscussionImage from '../../assets/carousel-1.jpg'; 

const articleContent = {
  title: 'Musisi & Pegiat Lingkungan Bergabung: FORPASI Memperkuat Suara Isu Sampah di Indonesia',
  date: '23 Juli 2024',
  author: 'Tim FORPASI',
  sections: [
    {
      type: 'paragraph',
      text: 'Dalam sebuah kolaborasi luar biasa yang penuh tujuan, lebih dari 30 musisi, seniman, dan pegiat lingkungan dari seluruh Indonesia bertemu di Jakarta awal bulan ini untuk menunjukkan komitmen mereka dalam mengatasi **krisis persampahan** yang kian mendesak.'
    },
    {
      type: 'paragraph',
      text: 'Aksi ini diorganisir oleh **FORPASI (Forum Menuju Indonesia Lestari)**, sebuah platform yang bertujuan untuk menyuarakan pendapat dari seluruh pihak di Indonesia kepada para pemangku kepentingan, guna meningkatkan kepedulian dan menciptakan sistem pengelolaan sampah yang lebih baik. Kegiatan ini didukung penuh oleh Kopernik.'
    },
    {
      type: 'image',
      src: GroupImage,
      caption: 'Sebagian peserta yang tergabung dalam gerakan FORPASI di Jakarta, membawa semangat "Indonesia Lestari".'
    },
    {
      type: 'paragraph',
      text: 'Selama workshop empat hari, para peserta diberi informasi dan data mendalam mengenai tantangan persampahan dari berbagai narasumber, termasuk data dari riset FORPASI sendiri. Tujuannya adalah memberdayakan mereka untuk menjadi **"Duta Sampah"** yang mampu mengkomunikasikan isu ini melalui medium seni dan musik yang kuat.'
    },
    {
      type: 'quote',
      text: '"Sinergi kita melalui seni dan musik bertujuan membentuk opini publik yang lebih peduli terhadap isu sampah, langkah penting menuju reformasi kebijakan dan regulasi yang berkelanjutan," ujar Bimo, salah satu inisiator FORPASI.'
    },
    {
      type: 'paragraph',
      text: 'FORPASI juga merupakan forum pertama yang berhasil menghadirkan gagasan dari 3 calon presiden pada pemilu 2024 terkait isu persampahan, menunjukkan peran non-partisannya dalam mendorong solusi persampahan nasional.'
    },
    {
      type: 'image',
      src: DiscussionImage,
      caption: 'Sesi diskusi mendalam mengenai advokasi kebijakan sampah di kantor Kopernik.'
    },
    {
      type: 'paragraph',
      text: 'Workshop ini ditutup dengan aksi simbolis pembersihan sungai di area Bogor, sebagai penanda komitmen untuk melanjutkan aksi nyata di daerah masing-masing. Karya-karya musik dan seni yang terinspirasi dari workshop ini diharapkan akan dirilis pada akhir tahun 2024.'
    },
  ],
  related: [
    { 
      title: 'Laporan Riset Terbaru: Tantangan Pengelolaan Sampah di Pulau Jawa', 
      date: '27 Juni 2024', 
      category: 'INSIGHTS & REPORTS',
      link: 'https://nationalgeographic.grid.id/read/134355252/hari-peduli-sampah-nasional-refleksi-tata-kelola-sampah-indonesia'
    },
    { 
      title: 'FORPASI Berkolaborasi dengan Pemerintah Daerah dalam Program "Desa Bebas Sampah"', 
      date: '20 Juni 2024', 
      category: 'NEWS',
      link: 'https://envira.id/begini-cara-unik-forpasi-peringati-hpsn/amp/'
    },
    { 
      title: 'Mengukur Jejak Karbon dari Sampah Plastik: Sebuah Eksperimen', 
      date: '28 Mei 2024', 
      category: 'INSIGHTS & REPORTS',
      link: 'https://validnews.id/nasional/menanti-asri-tak-diartikan-sekadar-kerja-bakti'
    },
  ]
};

const ForpasiNewsPageA = () => {
  // const { language } = useLanguage(); 
  
  // Menggunakan useEffect untuk animasi sederhana (opsional)
  useEffect(() => {
    // Logika animasi/reveal jika diperlukan, tapi kali ini kita fokus pada tampilan.
    console.log('Forpasi News Page Loaded');
  }, []);

  // Fungsi helper untuk merender konten artikel
  const renderArticleContent = () => {
    return articleContent.sections.map((section, index) => {
      switch (section.type) {
        case 'paragraph':
          // Gunakan highlightIndonesiaLestari jika ada, jika tidak, pakai strong tag biasa
          const highlightedText = section.text.replace(
            /(krisis persampahan|FORPASI|Duta Sampah)/g,
            '<strong>$1</strong>'
          );
          return <p key={index} dangerouslySetInnerHTML={{ __html: highlightedText }} />;
        case 'image':
          return (
            <figure key={index} className="article-image-container">
              <img src={section.src} alt={section.caption} className="article-image" />
              <figcaption>{section.caption}</figcaption>
            </figure>
          );
        case 'quote':
            return (
                <blockquote key={index}>
                    {section.text}
                </blockquote>
            );
        default:
          return null;
      }
    });
  };

  return (
    <div className="forpasi-news-page">
      {/* Header/Banner Utama */}
      <div className="news-hero-banner" style={{ backgroundImage: `url(${HeroImage})` }}>
        <div className="hero-overlay">
          <div className="hero-text-content">
            <h1 className="news-title">{articleContent.title}</h1>
            <p className="news-meta">
              <span>{articleContent.date}</span> oleh <span>{articleContent.author}</span>
            </p>
          </div>
        </div>
      </div>

      <div className="news-content-wrapper">
        <div className="main-article-content">
          {renderArticleContent()}
        </div>

        {/* Bagian Terkait Mirip Sidebar di PDF */}
        <div className="related-section">
          <h2>BERITA TERKAIT</h2>
          {articleContent.related.map((item, index) => (
            <div key={index} className="related-item">
              <span className="related-category">{item.category}</span>
              <a href={item.link} target="_blank" rel="noopener noreferrer" style={{ textDecoration: 'none', color: 'inherit' }}>
                <p className="related-title">{item.title}</p>
              </a>
              <span className="related-date">{item.date}</span>
            </div>
          ))}

          <hr/>

          {/* Contoh Footer CTA (seperti di PDF) */}
          <div className="newsletter-cta">
            <p>Dapatkan informasi terbaru dari FORPASI, langsung di inbox kamu.</p>
            <input type="email" placeholder="Email kamu"/>
            <button>SUBMIT</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ForpasiNewsPageA;